export function formatDurationTag(minutes?: number): string | null {
  if (minutes === undefined || minutes === null || Number.isNaN(minutes)) return null
  const rounded = Math.max(1, Math.round(minutes))
  return `${rounded} min`
}
